<section class="project-report-form" style="padding: 1rem;">
  <div id="estimate-form" class="progress-report">
    <div id="print-invoice-form" class="print-estimate">
      <header id="estimate-header" style="display: flex; margin-bottom: 2rem;">
        <section>
          <ng-container *ngIf="projectReport.ComapnyLogoFileURL" >
            <img class="company-logo" *ngIf="projectReport.ComapnyLogoFileURL" [src]="concatFilePath | memoizedFn:projectReport.ComapnyLogoURL: projectReport?.ComapnyLogoFileName" alt="company-logo" >
          </ng-container>
          <!-- <ng-template #noImage>
            <span class="image-placeholder">Add an Image</span>
          </ng-template> -->
          <div>
            <h1>{{projectReport.CompanyName}}</h1>
          </div>
          <div class="f-row" *ngIf="projectReport.LicenseNumber">
            <span style="overflow-wrap: anywhere">{{ projectReport.LicenseNumberName | licenseLabel }}</span><span>:</span><span
              style="padding-left: 4px; overflow-wrap: anywhere">{{projectReport.LicenseNumber}}</span>
          </div>
          <div *ngIf="!isEmpty(projectReport.CompanyAddress)" style="margin-bottom: 0.5rem">
            <div [innerHTML]="projectReport.CompanyAddress | addressFormat"></div>
          </div>
          <div>
            <div>{{projectReport.CompanyPhoneNo}}</div>
            <div [innerHTML]="projectReport.CompanyEmail | softBreak"></div>
            <div [innerHTML]="projectReport.CompanyWebsite | softBreak"></div>
          </div>
        </section>
        <section class="t-right">
          <div>
            <h1>{{projectReport.Name}}</h1>
          </div>
          <div>
            <small>Date: </small><span class="d-inline-block"
              style="min-width: 100px; display: inline-block">{{projectReport.Date|date:'mediumDate'}}</span>
          </div>
          <br />
          <div><strong>{{(projectReport.Project.Customer.FirstName || '')+'
              '+(projectReport.Project.Customer.LastName||'')}}</strong></div>
          <div *ngIf="!isEmpty(projectReport.Project?.Customer?.Address)">
            <div [innerHTML]="projectReport.Project.Customer.Address | addressFormat"></div>
          </div>
          <div *ngIf="projectReport.Project.Customer.PhoneNumbers?.length">
            {{projectReport.Project.Customer.PhoneNumbers[0].PhoneNumber}}
          </div>
          <div *ngIf="projectReport.Project.Customer.Emails?.length"> {{projectReport.Project.Customer.Emails[0].Email}}
          </div>
          <br />
          <div>
            <div>
              <strong>
                Project: {{projectReport.Project?.DisplayName}} {{(projectReport.Project?.ProjectNumber) ? (' - ' + projectReport.Project?.ProjectNumber) : ''}}
              </strong>
            </div>
          </div>
          <div *ngIf="!isEmpty(projectReport.Project?.Address)">
            <div [innerHTML]="projectReport.Project.Address | addressFormat"></div>
          </div>
        </section>
      </header>

      <ng-template #clientViewHidden>
        <div class="message"><i class="i-file-project-report mt-5 mb-3"></i>
          <div class="font-22 t-center mb-2"><span class="danger">This photo report has expired.</span></div>
          <div class="font-22 t-center">Please contact {{projectReport.CompanyName}} for assistance.</div>
        </div>
      </ng-template>

      <ng-container *ngIf="projectReport.IsPublished;else clientViewHidden">
        <section *ngFor="let item of projectReport.ProjectProgressReportSection">
          <div class="line-items">
            <table class="line-item-table itemized">
              <tbody class="line-item-table itemized">
                <tr class="table-row" style="line-height: 1">
                  <td colspan="2" style="padding: 0.5rem 0px; background-color: white">
                    <h3 style="margin-bottom: 8px"><strong>{{item.Title}}</strong></h3>
                    <div class="text-description description-inner innerHtmlCkEditorContent">
                      <p [innerHTML]="item.DescriptionHtml|sanitize" class="innerPara"></p>
                    </div>
                  </td>
                </tr>
                <ng-container *ngFor="let line of item.ProjectProgressReportItem">
                  <tr tabindex="1" class="table-row" style="line-height: 1; border-radius: 8px">
                    <td class="table-cell line-item amount-cell" style="width: auto; padding: 8px; border: none;">
                      <div *ngIf="line.UriPath; else noImage" class="report-image-container" style="text-align: left;">
                        <img [alt]="line.Title" [src]="photoThumbUrl | memoizedFn : line : $any(line)?._thumbFailed" (error)="onThumbError(line)" loading="lazy" class="project-report-image no-print"
                        [ngClass]="{ 'photo-sm': adjustPhotoSize(1), 'photo-md': adjustPhotoSize(2), 'photo-lg': adjustPhotoSize(3) }"
                        (click)="openImageInLightbox(line, item, $event)"
                        style="cursor: pointer;"/>
                        <img [alt]="line.Title" [src]="photoThumbUrl | memoizedFn : line : $any(line)?._thumbFailed" (error)="onThumbError(line)" loading="lazy"
                         class="project-report-image only-print-preview"
                        [ngClass]="{ 'photo-sm': adjustPhotoSize(1), 'photo-md': adjustPhotoSize(2), 'photo-lg': adjustPhotoSize(3) }"/>
                        <div class="image-download-overlay no-print">
                          <button class="image-download-btn" (click)="downloadPhoto(line, $event)" title="Download photo">
                            <i class="i-inbox"></i>
                          </button>
                        </div>
                      </div>
                        <ng-template #noImage>
                          <i class="delete-image">Image has been deleted</i>
                        </ng-template>

                    </td>
                    <td class="table-cell line-item"
                      style="width: 90%;vertical-align: top;padding: 0.5rem;border: none;">
                      <h4 style="margin-bottom: 4px">
                        {{line.Title}}
                      </h4>
                      <div>
                        <small style="margin-right: 0.5rem" *ngIf="line?.FileCreatedDate"><i
                            class="i-calendar-alt"></i>{{line?.FileCreatedDate|date:'mediumDate'}} </small>
                        <small *ngIf="line.ReportTag?.length" class="mr-2">
                          <span *ngFor="let tag of line.ReportTag" style="margin-right: 0.5rem;">{{tag?.TagName}}</span>
                        </small>
                        <div class="description-inner innerHtmlCkEditorContent">
                          <p [innerHTML]="line.DescriptionHtml | sanitize"></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </section>
        <section id="details">
          <div class="details">
            <div class="intro-text"></div>
          </div>
        </section>
      </ng-container>
    </div>


    <ng-container *ngIf="projectReport.IsPublished">
      <section id="details">
        <div class="details">
          <div class="intro-text"></div>
        </div>
      </section>
      <section style="margin-top: 2rem">
        <div class="f-row f-center no-print" style="gap: 1rem; flex-wrap: wrap;">
          <button class="round no-border" type="button" (click)="handlePrintPDF()">
            <i class="i-print"></i><span>Print {{projectReport.Name}}</span>
          </button>
          <button class="round no-border" type="button" (click)="downloadAllPhotos()" [disabled]="isDownloadingAll">
            <i class="i-inbox" *ngIf="!isDownloadingAll && !downloadComplete"></i>
            <span class="spinner-border spinner-border-sm" *ngIf="isDownloadingAll"></span>
            <i class="i-check" *ngIf="downloadComplete" style="color: #28a745;"></i>
            <span>{{ isDownloadingAll ? 'Preparing download...' : downloadComplete ? 'Download complete!' : 'Download all photos' }}</span>
          </button>
        </div>
      </section>
    </ng-container>
  </div>
</section>
